// Generic "show N more" reveal for an already-fully-rendered list — no fetch, just
// un-hides the next batch of [data-reveal-item][hidden] children. Used by
// sections/section-metaobject-related-tabs.liquid's Collections tab, whose source
// (an FF Theme's ff_collections field) is already capped at 50 and fully present in
// the page — unlike the Products tab, which can be much larger and needs the real
// fetch-based pagination in assets/product-related-tabs.js instead.
if (!customElements.get('reveal-batch-panel')) {
  customElements.define(
    'reveal-batch-panel',
    class extends HTMLElement {
      connectedCallback() {
        this.batchSize = Number(this.dataset.batchSize) || 10;
        const button = this.querySelector('[data-see-more]');
        if (!button) return;

        button.addEventListener('click', () => {
          const hiddenItems = Array.from(this.querySelectorAll('[data-reveal-item][hidden]'));
          hiddenItems.slice(0, this.batchSize).forEach((item) => item.removeAttribute('hidden'));
          if (hiddenItems.length <= this.batchSize) {
            button.hidden = true;
          }
        });
      }
    }
  );
}
